import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils';

const badgeVariants = cva(
  'inline-flex items-center gap-[0.3rem] whitespace-nowrap rounded-full border border-foreground/12 font-display font-semibold tracking-[0.08em] uppercase shadow-hard-sm',
  {
    variants: {
      variant: {
        default: 'bg-foreground text-background',
        pink: 'border-transparent bg-riso-pink text-white',
        teal: 'border-transparent bg-riso-teal text-white',
        amber: 'border-transparent bg-riso-amber text-white',
        blue: 'border-transparent bg-riso-blue text-white',
        outline: 'bg-background text-foreground',
        'outline-teal':
          'bg-background text-riso-teal border-riso-teal/30 shadow-none',
        'outline-pink':
          'bg-background text-riso-pink border-riso-pink/30 shadow-none',
      },
      size: {
        sm: 'px-2 py-[0.1rem] text-[10px]',
        default: 'px-3 py-1 text-xs',
        lg: 'px-4 py-1.5 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(badgeVariants({ variant, size, className }))}
      {...props}
    />
  ),
);
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
